import { useId } from "react";

export const Field = ({ label, help, error, children, required, testId }) => {
  const id = useId();
  const helpId = `${id}-help`;
  const errId = `${id}-err`;
  const describedBy = [help ? helpId : null, error ? errId : null].filter(Boolean).join(" ") || undefined;
  return (
    <div className="mb-6" data-testid={testId}>
      <label htmlFor={id} className="label">
        {label}{required && <span className="text-ink-500 font-normal"> (required)</span>}
      </label>
      {children({ id, "aria-describedby": describedBy, "aria-invalid": error ? true : undefined, "aria-required": required || undefined })}
      {help && <p id={helpId} className="help">{help}</p>}
      {error && <p id={errId} className="field-error" role="alert">{error}</p>}
    </div>
  );
};

export const FormError = ({ message, testId = "form-error" }) =>
  message ? (
    <div role="alert" className="mb-6 rounded border border-terracotta-600 bg-cream-100 px-4 py-3 text-ink-900" data-testid={testId}>
      {message}
    </div>
  ) : null;

export const FormSuccess = ({ message, testId = "form-success" }) =>
  message ? (
    <div role="status" className="mb-6 rounded border border-olive-900 bg-cream-100 px-4 py-3 text-ink-900 confirm-pop" data-testid={testId}>
      {message}
    </div>
  ) : null;
